export { useRouteParams } from "./useRouteParams";

export const HOME_ROUTE = "/docs";
